const facility = [
    { type: 'required', message: 'Facility is required' },
    { type: 'minLength', message: 'Facility name must be at least 3 characters long' },
    { type: 'maxLength', message: 'Facility name cannot be more than 24 characters long' },
    { type: 'pattern', message: 'Your name must contain only numbers and letters' },
    // { type: 'validFirstname', message: 'Your name has already been taken' },
    // { type: 'areEqual', message: 'You entered wrong username' },
]

export default { facility };